/* eslint-disable */
import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { protectedRoutes, publicRoutes } from "./Routes";
import packageJson from "../../package.json";

let basename = '/';

if (packageJson.homepage){
    try{
        basename = new URL(packageJson.basename).pathname;
    } catch (e){
        basename = packageJson.homepage;
    }
}

const Authmiddleware = () => {
    const token = localStorage.getItem("token");

    console.log("Authmiddleware token:", token);

    const location = useLocation();

    return (
        <Routes basename ={basename}>
            {/* Public Routes */}
            {!token &&publicRoutes.map((route, index) => {
                return route.component ? (
                    <Route
                        key={index}
                        path={route.path}
                        element={<route.component />}
                    />
                ) : null;
            })}

            {/* Protected Routes */}
            {token &&protectedRoutes.map((route, index) => {
                return route.component ? (
                    <Route
                        key={index}
                        path={route.path}
                        element={
                            token ? (
                                <route.component />
                            ) : (
                                <Navigate to="/login" state={{ from: location.pathname }} />
                            )
                        }
                    />
                ) : null;
            })}

            {/* Default Redirects */}
            <Route
                path="*"
                element={token ? <Navigate to="/dashboard" /> : <Navigate to="/login" />}
            />
        </Routes>
    );
};

export default Authmiddleware;